import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    // Set target to 24 hours from now on mount
    const targetTime = new Date().getTime() + 24 * 60 * 60 * 1000;
    const interval = setInterval(() => {
      const now = new Date().getTime();
      const difference = targetTime - now;
      if (difference <= 0) {
        clearInterval(interval);
        setTimeLeft({
          hours: 0,
          minutes: 0,
          seconds: 0
        });
        return;
      }
      const hours = Math.floor(difference % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
      const minutes = Math.floor(difference % (1000 * 60 * 60) / (1000 * 60));
      const seconds = Math.floor(difference % (1000 * 60) / 1000);
      setTimeLeft({
        hours,
        minutes,
        seconds
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  return <div className="flex items-center justify-center gap-4 text-white font-mono text-3xl md:text-4xl font-bold" data-id="element-98">
      <div className="flex flex-col items-center" data-id="element-99">
        <div className="bg-slate-800 rounded-lg px-4 py-2 min-w-[80px] text-center" data-id="element-100">
          {formatNumber(timeLeft.hours)}
        </div>
        <span className="text-xs text-slate-400 mt-2 font-sans uppercase tracking-wider" data-id="element-101">
          Horas
        </span>
      </div>
      <span className="text-brand-accent -mt-6" data-id="element-102">:</span>
      <div className="flex flex-col items-center" data-id="element-103">
        <div className="bg-slate-800 rounded-lg px-4 py-2 min-w-[80px] text-center" data-id="element-104">
          {formatNumber(timeLeft.minutes)}
        </div>
        <span className="text-xs text-slate-400 mt-2 font-sans uppercase tracking-wider" data-id="element-105">
          Min
        </span>
      </div>
      <span className="text-brand-accent -mt-6" data-id="element-106">:</span>
      <div className="flex flex-col items-center" data-id="element-107">
        <div className="bg-slate-800 rounded-lg px-4 py-2 min-w-[80px] text-center" data-id="element-108">
          {formatNumber(timeLeft.seconds)}
        </div>
        <span className="text-xs text-slate-400 mt-2 font-sans uppercase tracking-wider" data-id="element-109">
          Seg
        </span>
      </div>
    </div>;
}